import * as React from 'react';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkMark, UitkMarkSize } from 'uitk-react-mark';
import { iconSizeMapper } from '../../business/icon-size';
export var IconMark = function (_a) {
  var _b;
  var icon = _a.icon,
    mark = _a.mark,
    defaultIconSize = _a.defaultIconSize,
    markSize = _a.markSize,
    className = _a.className,
    withBackground = _a.withBackground;
  var canRenderIcon = icon && !mark;
  var iconToRender = icon;
  var iconSize = (iconToRender === null || iconToRender === void 0 ? void 0 : iconToRender.size) && iconSizeMapper[iconToRender === null || iconToRender === void 0 ? void 0 : iconToRender.size];
  markSize = markSize || UitkMarkSize.LARGE;
  defaultIconSize = defaultIconSize || UitkIconSize.LARGE;
  var background = withBackground === true ? 'info' : undefined;
  return React.createElement(React.Fragment, null, mark && React.createElement(UitkMark, {
    name: mark.id,
    size: markSize,
    className: className,
    url: (_b = mark === null || mark === void 0 ? void 0 : mark.url) === null || _b === void 0 ? void 0 : _b.value
  }), canRenderIcon && React.createElement(UitkIcon, {
    name: iconToRender === null || iconToRender === void 0 ? void 0 : iconToRender.id,
    size: iconSize || defaultIconSize,
    className: className,
    id: iconToRender === null || iconToRender === void 0 ? void 0 : iconToRender.id,
    description: iconToRender === null || iconToRender === void 0 ? void 0 : iconToRender.description,
    spotlight: background
  }));
};